module.exports = __webpack_public_path__ + "static/media/46.6dbdeee3.jpg";